import React, { useContext, useState } from "react";
import { Td, Tooltip, Tr } from "@chakra-ui/react";
import MenuRUD from "components/Menu/MenuRUD";
import styled from "styled-components/macro";
import { BsCheckCircleFill } from "react-icons/bs";
import { IconGeneric } from "styled/Icons.styled";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import environment from "constants/apiConst";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useSelector } from "react-redux";
import { __Show_Packaging } from "../../request/configuration/__Packaging";
import { ConfigIconStatus } from "pages/Configuration/tables/components/LoadingConfig";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;

const TbodyPackaging = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const { setUpdate, update, setLoading } = useContext(
    ConfigurationCRUDContext
  );
  const [loadingIcons, setLoadingIcons] = useState(false);
  const [openAlert] = AlertErrorAlert();

  const desactivarAndActivar = async (result) => {
    setLoading(true);
    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(token, environment.PACKAGING_DESACTIVE, data.id)
          : await __ACTIVAR(token, environment.PACKAGING_ACTIVE, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleState = async () => {
    setLoadingIcons(true);

    try {
      const res = await __Show_Packaging(token, data.id);
      const result = res.data.status.data.status_packaging;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingIcons(true);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data?.code_packaging}</Td>
      <Td className="text-center">{data?.name_packaging}</Td>
      <Tooltip
        placement="top"
        hasArrow
        label={data?.status_packaging === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={handleState}
          className="text-center"
          isNumeric
          text={data?.status_packaging}
        >
          <ConfigIconStatus
            loading={loadingIcons}
            status={data?.status_packaging}
          />
        </TdState>
      </Tooltip>
      <Td className="text-center" isNumeric>
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TbodyPackaging;
